import { render, staticRenderFns } from "./ModalDuplicateQuotation.vue?vue&type=template&id=1646837c&"
import script from "./ModalDuplicateQuotation.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicateQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports